module.exports = __webpack_public_path__ + "img/f8bfc46.png";